define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"csi/html",
	"csi/locale",
	"csi/xml"
], function(declare,Ref,html,locale,xml) {

	return declare(Ref, {
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			var node = ctx.getNode();
			if (node && node.StateChangeTime && !xml.isValidURL(node.StateChangeUser)) {
				html.setInnerText(refNode, locale.resource("Workflow_User_Name"));
				return true;
			}
			
			return this.inherited(arguments);
		}
	});
});